import { useFormikContext } from 'formik';
import React from 'react';
import { CreatWidgetFormValues, WidgetTypes } from '../../dashboard-widget-model';
import { BarChartWidgetForm } from './BarChartWidgetForm';
import { LineChartWidgetForm } from './LineChartWidgetForm';
import { PieChartWidgetForm } from './PieChartWidgetForm';

export function NumberChartWidgetForm() {
  const { values: formValues } = useFormikContext<CreatWidgetFormValues>();

  switch (formValues.chartWidgetType) {
    case WidgetTypes.BAR:
    case WidgetTypes.COLUMN:
      return <BarChartWidgetForm maxValue={1} />;
    case WidgetTypes.LINE:
    case WidgetTypes.AREA:
      return <LineChartWidgetForm maxValue={1} />;
    case WidgetTypes.PIE:
      return <PieChartWidgetForm />;
    default:
      return null;
  }
}
